import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "min-width" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "address" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_CompanyIcon = _resolveComponent("CompanyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_flex, {
      class: "content",
      justify: "space-between",
      align: "flex-top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_flex, {
            align: "center",
            class: "left"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "card",
                  onClick: ($event: any) => (_ctx.gotoPage(item.name))
                }, _toDisplayString(item.title), 9, _hoisted_2))
              }), 128))
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_flex, {
              align: "center",
              class: "address-top"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", null, "地址：山东省烟台市芝罘区南大街11号壹通国际21楼", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_a_flex, { align: "center" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "address-left" }, "电话：（0535）6233306", -1),
                _createElementVNode("div", null, "网址：www.wozhida.cn", -1)
              ])),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_CompanyIcon, {
          class: "right",
          pattern: "white",
          size: "irregular"
        })
      ]),
      _: 1
    }),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info" }, " 山东沃智达技术有限公司 Copyright @ 2021 沃智达. All Rights Reserved | www.wozhida.cn ", -1))
  ]))
}